import { Svg } from '../../../../../..'

interface ChevronProps {
  className?: string
}

export const Chevron = ({ className }: ChevronProps) => (
  <Svg
    width='12'
    height='13'
    viewBox='0 0 12 13'
    className={className}
    fill='currentColor'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M6 10.1429L0 4.14286L0.642857 3.5L6 8.85714L11.3571 3.5L12 4.14286L6 10.1429Z' />
  </Svg>
)
